export default "__VITE_ASSET__608c188c__"